import cn from 'classnames';
import { WEBSITE_URL } from 'core-lib/data/common';
import { useEffect, useState } from 'react';
import { Chip, Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import { ChipVariants } from 'ui/primitives/ChipTypes';
import { ModelDetailType, VariantsListType } from '../../types';
import { getOptions } from '../../utils/helper';
import { VariantListingCard } from '../cards/VariantListingCard/VariantListingCard';
import s from './FilterVariantList.module.scss';
import FilterVariantListingCard from '../cards/FilterVariantListingCard';

export const FilterVariantList = ({
  list,
  label,
  modelName,
  modelImage,
  brandSlug,
  modelSlug,
  contentData = null,
}: {
  list: VariantsListType[];
  label: string;
  modelName: string;
  modelImage: string;
  modelSlug: string;
  brandSlug: string;
  contentData?: ModelDetailType;
}) => {
  const [filteredVariants, setFilteredVariants] = useState(list);
  const [activeFilter, setActiveFilter] = useState({
    fuel: [],
    transmission: [],
  });
  const [filterOptions, setFilterOptions] = useState(getOptions(list));

  function handleFilterClick(type, value) {
    if (type === 'fuel') {
      if (activeFilter.fuel?.includes(value)) {
        setActiveFilter({
          ...activeFilter,
          fuel: activeFilter?.fuel
            ?.map((obj) => obj?.toLowerCase())
            ?.filter((obj) => obj !== value),
        });
      } else {
        setActiveFilter({
          ...activeFilter,
          fuel: [...activeFilter.fuel, value],
        });
      }
    } else if (type === 'transmission') {
      if (activeFilter?.transmission?.includes(value)) {
        setActiveFilter({
          ...activeFilter,
          transmission: activeFilter?.transmission
            ?.map((obj) => obj?.toLowerCase())
            ?.filter((obj) => obj !== value),
        });
      } else {
        setActiveFilter({
          ...activeFilter,
          transmission: [...activeFilter.transmission, value],
        });
      }
    }
  }

  useEffect(() => {
    if (activeFilter?.fuel?.length || activeFilter?.transmission?.length) {
      let tempFilteredVariants = list?.filter((obj) => {
        if (activeFilter?.transmission?.length) {
          if (activeFilter?.transmission?.includes(obj?.transmission)) {
            return true;
          }
        }
        if (activeFilter?.fuel?.length) {
          if (activeFilter?.fuel?.includes(obj?.fuelType?.toLowerCase())) {
            return true;
          }
        }
        return false;
      });
      setFilteredVariants(tempFilteredVariants);
    } else setFilteredVariants(list);
  }, [activeFilter, list]);
  return (
    <div className={s.container}>
      <div className={s.root}>
        <Typography label={label} variant={TypeScales.h2} renderAs="H1" />
        <div className={s.filters}>
          {!!filterOptions?.fuel?.length &&
            filterOptions?.fuel?.map(
              (obj) =>
                obj && (
                  <button
                    type="button"
                    className={cn('cmn_touchable_area', s.filter_btn)}
                    key={obj?.name}
                    onClick={() => handleFilterClick('fuel', obj.toLowerCase())}
                  >
                    <Chip
                      variant={ChipVariants.Filter}
                      label={obj}
                      showCross
                      state={
                        activeFilter?.fuel?.includes(obj.toLowerCase())
                          ? 'selected'
                          : 'enabled'
                      }
                    />
                  </button>
                )
            )}
          {!!filterOptions?.transmission?.length &&
            filterOptions?.transmission?.map(
              (obj) =>
                obj && (
                  <button
                    type="button"
                    className={cn('cmn_touchable_area', s.filter_btn)}
                    key={obj?.name}
                    onClick={() =>
                      handleFilterClick('transmission', obj.toLowerCase())
                    }
                  >
                    <Chip
                      variant={ChipVariants.Filter}
                      label={obj}
                      showCross
                      state={
                        activeFilter?.transmission?.includes(obj.toLowerCase())
                          ? 'selected'
                          : 'enabled'
                      }
                    />
                  </button>
                )
            )}
        </div>
        <div className={s.list}>
          {filteredVariants?.map((obj) => (
            <FilterVariantListingCard
              variantDetail={obj}
              modelName={modelName}
              modelImage={modelImage}
              key={obj?.slug}
              link={`${WEBSITE_URL}/new-cars/${brandSlug}-car/${modelSlug}/${obj?.variantName
                ?.toLowerCase()
                ?.replace(/ /g, '-')}-variant`}
              modelId={contentData?.modelId}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
